var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-management-wrapper"},[(_vm.isGlNavigationEnabled)?_c('LazyGLListOrder'):_c('LazyGLListWithNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }